/**
 * 社区模块全局配置
 */

/** 瀑布流 Feed 最大列数（2-5） */
export const COMMUNITY_FEED_COLUMNS = 3;

export type CommunitySidebarAd = {
  id: string;
  imageUrl: string;
  linkUrl: string;
  alt?: string;
};

const publicBaseUrl = import.meta.env.BASE_URL;

/** 社区右侧栏广告位配置：展示图片与点击跳转地址 */
export const COMMUNITY_SIDEBAR_ADS: CommunitySidebarAd[] = [
  {
    id: "beyond",
    imageUrl: `${publicBaseUrl}images/AD-beyond.png`,
    linkUrl: `https://beyond.mxgent.cn`,
    alt: "beyond",
  },
  {
    id: "academy-hero",
    imageUrl: `${publicBaseUrl}images/academy/hero-illustration.png`,
    linkUrl: `${publicBaseUrl}academy`,
    alt: "SafeClaw Academy",
  },
];
